<template>
	<div id="message">
		<top></top>
		<div class="mian" :style="{ height: mianH + 'px' }">
			<div class="apart_list">
				<left></left>
				<ChapterAddUpdate />
			</div>

		</div>
	</div>
</template>
<script>
import top from '../components/top.vue' //顶部
import left from '../components/left.vue' //左侧
import ChapterAddUpdate from '@/components/chapter_add_update' 
import { EventBus } from '@/utils/eventBus';
export default {
	components: {
		top, left,ChapterAddUpdate
	},
	data() {
		return {
			mianH: 0,//主题区域宽度
		}
	},
	mounted() {
		this.calculateMianHeight();
		window.addEventListener('resize', this.calculateMianHeight);
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.calculateMianHeight);
	},
	methods: {
		calculateMianHeight() {
			this.mianH = window.innerHeight - 63;
		},
	},
}
</script>

<style>
#message {
	width: 100%;
	height: 100vh;
	display: flex;
	flex-flow: column;
}

.apart_list {
	display: flex;
	flex: 1;
}
</style>